import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white/50 flex gap-4 h-[46px]" }
const _hoisted_2 = { class: "flex h-full ml-8" }

import BrandBar from "@/components/identity/BrandBar.vue";
import NavigationButton from "./NavigationButton.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Navigation',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(BrandBar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NavigationButton, { to: "/" }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Home ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(NavigationButton, { to: "/about" }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" About ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(NavigationButton, { to: "/contact" }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Contact ", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})